exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html,\nbody,\n\n.app {\n  height: 100vh;\n}\n", ""]);

